'use client';

import { useState, type ReactNode } from 'react';
import { Pause, Play } from 'lucide-react';

/**
 * 会員様の声の無限マーキー本体（クライアント）。
 * カード（Server Component）は children として受け取り、SSR結果をそのまま流す。
 * 目的: WCAG 2.2.2（5秒超の自動スクロールは停止可能に）を満たす一時停止ボタンを提供する。
 * hover/focus での一時停止は補助であり、キーボード・タッチでも操作できる明示ボタンが本体。
 */
export default function TestimonialMarquee({
  children,
  durationSec,
  label,
}: {
  children: ReactNode;
  durationSec: number;
  label: string;
}) {
  const [paused, setPaused] = useState(false);

  return (
    <div className='relative' role='region' aria-label={label}>
      <div className='marquee py-4'>
        <ul
          className={`marquee__track${paused ? ' is-paused' : ''}`}
          style={{ animationDuration: `${durationSec}s` }}
        >
          {children}
        </ul>
      </div>

      <button
        type='button'
        onClick={() => setPaused((p) => !p)}
        aria-pressed={paused}
        aria-label={paused ? '再生' : '一時停止'}
        // 動きに弱いユーザー向けには自動スクロールが無効なため、ボタンも隠す
        className='absolute bottom-4 right-4 z-10 inline-flex h-9 w-9 items-center justify-center rounded-full border border-line bg-white/85 text-ink-2 shadow-sm backdrop-blur-sm transition-colors hover:border-primary/40 hover:text-primary motion-reduce:hidden md:right-6'
      >
        {paused ? <Play className='h-4 w-4' /> : <Pause className='h-4 w-4' />}
      </button>
    </div>
  );
}
